import React, { PropsWithChildren } from "react";

function ChevronIcon(props: PropsWithChildren<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="15"
      fill="none"
      viewBox="0 0 9 15"
      style={{cursor:"pointer"}}
      {...props}
    >
      <path
        fill="#522398"
        d="M8.078 7.992a.68.68 0 00.055-.93L1.68.72C1.406.445.969.445.75.719l-.383.383a.63.63 0 000 .93L5.945 7.5.367 13.023a.63.63 0 000 .93l.383.383c.219.273.656.273.93 0l6.398-6.344z"
      ></path>
    </svg>
  );
}

export default React.memo(ChevronIcon);
